// Naira / Dollar switch shared by every checkout (coins, Pro).
const OPTIONS = [
  ["NGN", "₦ Naira"],
  ["USD", "$ Dollar"],
];

export default function CurrencyToggle({ currency, onChange, disabled = false }) {
  return (
    <div role="radiogroup" aria-label="Currency" className="inline-flex p-0.5 rounded-lg bg-brand-input">
      {OPTIONS.map(([code, label]) => (
        <button
          key={code}
          type="button"
          role="radio"
          aria-checked={currency === code}
          disabled={disabled}
          onClick={() => onChange(code)}
          className={`px-3 h-8 rounded-md text-xs font-semibold transition-colors ${
            currency === code
              ? "bg-brand-surface text-brand-text shadow-[0_1px_2px_rgba(0,0,0,0.08)]"
              : "text-brand-textSecondary hover:text-brand-text"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
